import { createSelector } from 'reselect';

import { getSelectedGroupId } from 'modules/groups/selectors';

/** @return {import("reducers/modelReducer").ModelReducer} */
const getState = state => state.models;

const getProps = (_, props) => props;

const getData = createSelector(getState, models => models.data);

const getAllData = createSelector(getData, data => data.all);

export const getModelsContent = createSelector(getAllData, all => all.items);

export const getModelsContentPage = createSelector(getAllData, all => all.page);

const getModelsContentCurrentPage = createSelector(getModelsContentPage, page => page?.number ?? 0);

const getModelsSelectState = createSelector(getData, data => data.select);

export const getModelsSelect = createSelector(getModelsSelectState, select => select.items);

export const getModelsSelectArray = createSelector(getModelsSelect, models => Object.values(models));

export const getModelsApiError = createSelector(getState, state => state.apiError);

export const getModelsSelectLinks = createSelector(getModelsSelectState, select => select.links);

export const getModelsIsFetching = createSelector(getState, models => models.isFetching);

export const getSelectedModelDerivatives = createSelector(
  getModelsContent,
  getProps,
  (models, id) => models[id]?.derivative ?? []
);

export const getModelsFilters = state => state.models.filters || {};

export const getModelsIsUploading = createSelector(getState, state => state.isUploading);

export const getCurrentModelUploading = createSelector(getState, models => models.currentUploadedModel);

export const getNbFilesToUpload = createSelector(getState, models => models.nbFilesToUpload);

export const getLengthToUpload = createSelector(getState, models => models.lengthToUpload);

export const hasFilesToUpload = createSelector(getNbFilesToUpload, nbFilesToUpload => nbFilesToUpload > 0);

const getModelTable = createSelector(getState, state => state.table);

const getModelsTablePageSize = createSelector(getModelTable, table => table.pageSize);

const getModelsTableSort = createSelector(getModelTable, table => table.sort);

const getModelsTableSearchString = createSelector(getModelTable, table => table.searchString);

export const getOnlyValidModels = createSelector(getModelTable, table => table.onlyValidModels);

export const getModelsTableParameters = createSelector(
  getModelsContentCurrentPage,
  getModelsTableSort,
  getModelsTableSearchString,
  getModelsTablePageSize,
  getOnlyValidModels,
  getSelectedGroupId,
  (page, sort, text, size, valid, groupId) => ({
    projection: 'page',
    page,
    sort,
    text,
    size,
    groupId,
    to: valid ? null : new Date().toISOString(),
  })
);

const getModal = createSelector(getState, state => state.modal);

const getUpdateModal = createSelector(getModal, modal => modal.update);

const getUpdateModalModelId = createSelector(getUpdateModal, update => update.modelId);

export const getUpdateModalIsLoading = createSelector(getUpdateModal, update => update.isLoading);

export const getUpdateModalError = createSelector(getUpdateModal, update => update.error);

export const isUpdateModalVisible = createSelector(getUpdateModal, update => update.isVisible);

export const getUpdateModalModel = createSelector(
  getModelsContent,
  getUpdateModalModelId,
  (content, id) => content?.[id]
);

const getModelParam = (_, model) => model;

const getModel = createSelector(getModelParam, getModelsSelect, (model, models) => models[model] ?? {});

export const getModelBrandId = createSelector(getModel, model => model.brandId);
